__turbopack_context__.v({
  "viewportBottomLeft": "alarm-layer-popup-module__qjjmGG__viewportBottomLeft",
});
